// "Open in Drive" style link button with an external-link icon, used wherever
// the app hands off to a Google Drive file or folder.
import React from 'react';

export default function OpenLink({ href, children = 'Open', small = true, className = '', style, title }) {
  if (!href) return null;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" title={title || 'Opens in Google Drive'}
      className={`btn btn-accent ${small ? 'btn-sm' : ''} ${className}`} style={style}>
      {children}
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" />
      </svg>
    </a>
  );
}
